import { Search, X } from 'lucide-react';

export default function FilterBar({ fields, values, onChange, onClear }) {
  const hasValues = Object.values(values).some((v) => v !== '' && v !== null && v !== undefined);

  return (
    <div className="flex flex-wrap items-center gap-2 mb-4">
      {fields.map((field) => {
        if (field.type === 'text') {
          return (
            <div key={field.key} className="relative">
              <Search size={13} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" />
              <input
                type="text"
                value={values[field.key] ?? ''}
                onChange={(e) => onChange(field.key, e.target.value)}
                placeholder={field.label}
                className="pl-8 pr-3 py-1.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent w-40"
              />
            </div>
          );
        }
        if (field.type === 'select') {
          return (
            <select
              key={field.key}
              value={values[field.key] ?? ''}
              onChange={(e) => onChange(field.key, e.target.value)}
              className="px-3 py-1.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white text-gray-700"
            >
              <option value="">{field.label}</option>
              {field.options.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          );
        }
        if (field.type === 'date') {
          return (
            <div key={field.key} className="flex items-center gap-1">
              <span className="text-xs text-gray-400">{field.label}</span>
              <input
                type="date"
                value={values[field.key] ?? ''}
                onChange={(e) => onChange(field.key, e.target.value)}
                className="px-2 py-1.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
          );
        }
        return null;
      })}
      {hasValues && (
        <button onClick={onClear} className="flex items-center gap-1 px-2 py-1.5 text-xs text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors">
          <X size={12} /> Clear
        </button>
      )}
    </div>
  );
}
